namespace MACRAIL.Helpers {

export function createQtip(opts: MacrailQtipOptions): QTip2.Api {

    let position: QTip2.Position = {
        'adjust': {
            'method': 'shift',
        },
        'target': opts.target,
    };

    switch (opts.position) {
        case 'above':
            position.my = 'bottom center';
            position.at = 'top center';
            break;
        case 'below':
            position.my = 'top center';
            position.at = 'bottom center';
            break;
        case 'left':
            position.my = 'right center';
            position.at = 'left center';
            break;
        case 'right':
            position.my = 'left center';
            position.at = 'right center';
            break;
    }

    if (!opts.class) {
        opts.class = 'default';
    }

    if (opts.extraClasses) {
        opts.extraClasses = ' ' + opts.extraClasses;
    } else {
        opts.extraClasses = '';
    }

    // HACK: There's an ugly double-width border on the tip for above/below qTips.
    // Changing the width doesn't fix it :(.
    let tipWidth = 11;
    if (opts.position === 'above' || opts.position === 'below') {
        tipWidth = 11;
    }

    let target = $(opts.target);
    target.qtip({
        'content': {
            'title': opts.title || '',
            'text': opts.content || '',
        },
        'style': {
            'classes': 'qtip-macrail qtip-' + opts.class + opts.extraClasses,
            'tip': {
                'corner': true,
                'height': 7,
                'width': tipWidth,
            },
        },
        'position': position,
        'show': {
            'event': opts.event || false,
            'ready': false,
        },
        'hide': {
            'event': 'unfocus',
        },
    });

    return target.qtip('api');
}

export function makeUrl(opts: any) {

    let params: any = {};

    if (opts.eventId) {
        params.e = opts.eventId;
    } else if (GLOBALS.hasEvent) {
        params.e = GLOBALS.eventId;
    }

    params.com = opts.controller || GLOBALS.controller;

    if (params.com.substr(0, 3) !== 'com') {
        params.com = 'com' + params.com;
    }

    if (opts.action) {
        params.task = opts.action;
    } else if (GLOBALS.action) {
        params.task = GLOBALS.action;
    }

    if (opts.item) {
        params.item = opts.item;
    }

    $.extend(params, opts.params);

    return GLOBALS.siteUrl + 'index.php?' + $.param(params);
}

export function escapeHtml(text: string) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

export function formatDuration(time1: any | number | Date, time2: any | number | Date | undefined, opts: any) {

    if (time1.getTime) {
        time1 = time1.getTime();
    }

    let duration = 0;

    if (time2) {
        if (time2.getTime) {
            time2 = time2.getTime();
        }
        duration = time2 - time1;
    } else {
        duration = time1;
        opts = time2;
    }

    opts = opts || {};
    opts.format = opts.format || 'short';
    opts.includeZero = opts.includeZero || false;

    if (isNaN(duration)) {
        return undefined;
    }

    duration /= 1000;

    let hours = Math.floor(duration / 3600);
    let mins = Math.floor((duration % 3600) / 60);

    let h = 'h';
    let m = 'm';

    if (opts.format === 'long') {
        h = ' hour' + (hours === 1 ? '' : 's') ;
        m = ' minute' + (mins === 1 ? '' : 's');
    }

    if (opts.includeZero) {
        return hours + h + ' ' + mins + m;
    } else {
        if (hours === 0) {
            return mins + m;
        } else if (mins === 0) {
            return hours + h;
        } else {
            return hours + h + ' ' + mins + m;
        }
    }
}

export function formatRelativeTime(time: Date, now?: Date | undefined) {
    if (!now) {
        now = new Date();
    }

    let text = time.getFormatted('H:i');

    let diffSeconds = Math.abs(Math.round((now.getTime() - time.getTime()) / 1000));

    let days = Math.floor(diffSeconds / 86400);

    let hours = Math.floor((diffSeconds % 86400) / 3600);
    let minutes = Math.floor((diffSeconds % 3600) / 60);
    let seconds = diffSeconds % 60;

    let before = time.getTime() < now.getTime();

    let html = '';

    if (days > 14) {
        html = `${days}d`;
    } else if (days > 0) {
        html = `${days}d ${hours}h`;
    // } else if (hours > 0) {
    //     html = `${hours}h ${minutes}m`;
    } else {
        let diff = Math.abs(Math.round((diffSeconds) / (3600 / 4)));

        // var fracs = ['', ' &frac14;', ' &frac12;', ' &frac34;'];
        // var fracs = ['', ' 1/4', ' 1/2', ' 3/4'];
        let fracs = ['', '<sup>1</sup>⁄<sub>4</sub>', '<sup>1</sup>⁄<sub>2</sub>', '<sup>3</sup>⁄<sub>4</sub>'];

        if (diff === 0) {
            html = 'now';
        } else if (diff <= 3) {
            html = fracs[diff % 4] + ' hr';
        } else if (diff <= 4) {
            html = '1 hr';
        } else {
            html = Math.floor(diff / 4) + ' ' + fracs[diff % 4] + ' hrs';
        }
    }

    if (html !== 'now') {
        if (before) {
            html = html + ' ago';
        } else {
            html = 'in ' + html;
        }
    }

    return html;
}


export function parseQueryString(queryString?: string) {
    if (queryString === undefined) {
        queryString = location.search;
    }
    let params = {};
    queryString.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, key, value) { params[key] = value; return ''; });

    return params;
}

export function setQueryString(params: object): string;
export function setQueryString(url: string|object, params?: object): string {
    if (typeof(url) !== 'string') {
        params = url;
        url = document.location.href;
    }

    let currentParams = this.parseQueryString(url);

    let newParams = $.extend({}, currentParams, params);

    if (url.indexOf('?') > -1) {
        url = url.substr(0, url.indexOf('?'));
    }

    let urlParts: string[] = [];
    for (let prop in newParams) {
        if (!newParams.hasOwnProperty(prop)) {
            continue;
        }
        urlParts.push(prop + '=' + encodeURIComponent(newParams[prop]));
    }

    if (urlParts.length === 0) {
        return url;
    }

    return url + '?' + urlParts.join('&');
}

export function setButtonsetValue(id: string, value: string) {
    $('#' + id + ' [value="' + value + '"]').trigger('click');
}

}
